import { useEffect, useState } from 'react';
import { getMdmsReminderPhase } from '../utils/istTime';

export function MdmsReminderBanner({ phase, message }) {
  if (!phase || phase === 'none' || !message) return null;

  const isFinal = phase === 'final';

  return (
    <div
      className={
        isFinal
          ? 'rounded-lg border border-danger/50 bg-danger/10 px-3 py-2.5 text-sm font-medium text-text'
          : 'rounded-lg border border-warning/40 bg-warning/10 px-3 py-2 text-sm text-text'
      }
      role="status"
    >
      {message}
    </div>
  );
}

/** Re-check IST phase every minute so banners appear at 10:30 / 11:00 without refresh. */
export function useMdmsPhaseLive() {
  const [phase, setPhase] = useState(() => getMdmsReminderPhase());
  useEffect(() => {
    const tick = () => setPhase(getMdmsReminderPhase());
    tick();
    const id = setInterval(tick, 60_000);
    return () => clearInterval(id);
  }, []);
  return phase;
}
